module.exports = __webpack_public_path__ + "media/images/pages/secondary-toolkit/impact_of_tech-d91107d2b746cddcab39724678d9b363.png";